// @flow
import React, { Component } from "react";
import _ from "lodash";
import Waypoint from "react-waypoint";
import Scroll from "react-scroll";
import I18n from "../../../i18n/I18n";
import ItemNumber from "../../orders/itemNumber/ItemNumber";
import { ProductNameBox } from "../../common";
import Helper from "../../../helper/Helper";
import styles from "./PaymentDetailsMobile.scss";

class PaymentDetailsMobile extends Component {
    render() {
        const {
            total,
            currencyCode,
            deductions,
            totalCredit,
            seller,
            history,
            loadFunc,
            scroll,
            showNoLoading,
            docType
        } = this.props;
        const data = this.props.data || "";

        const property = Helper.validator(data);

        const paymentDetailsMobile = data
            ? data.map((payment, index) => {
                  return (
                      <div key={index} className={styles.ctr}>
                          <div
                              className={styles.flexer}
                              onClick={() =>
                                  this.props.toggleDetails(payment.itemId)
                              }
                          >
                              <div className={styles.statusCtr}>
                                  <div className={styles.date}>
                                      <ProductNameBox
                                          hideBadge
                                          data={payment}
                                      />
                                  </div>
                              </div>
                              <div className={styles.txnType}>
                                  <strong>
                                      {I18n.getText(
                                          "statement-details.partner-sku",
                                          {},
                                          "Partner SKU"
                                      )}
                                      : &nbsp;
                                  </strong>
                                  {payment.partnerSku}
                              </div>
                          </div>
                          <div className={styles.attrCtr}>
                              <div className={styles.eachAttr}>
                                  <h6 className={styles.attrTitle}>
                                      {I18n.getText(
                                          "statement-details.sku",
                                          {}
                                      )}
                                  </h6>
                                  <div className={styles.attrVal}>
                                      {payment.sku}
                                  </div>
                              </div>
                              <div className={styles.eachAttr}>
                                  <h6 className={styles.attrTitle}>
                                      {I18n.getText(
                                          "statement-details.item-no",
                                          {}
                                      )}
                                  </h6>
                                  <div className={styles.attrVal}>
                                      <ItemNumber
                                          itemNr={payment.itemNr}
                                          seller={seller}
                                          history={history}
                                      />
                                  </div>
                              </div>
                              <div
                                  className={styles.eachAttr}
                                  onClick={() =>
                                      this.props.toggleDetails(payment.itemId)
                                  }
                              >
                                  <h6 className={styles.attrTitle}>
                                      {I18n.getText(
                                          "statement-details.units",
                                          {},
                                          "units"
                                      )}
                                  </h6>
                                  <div className={styles.attrVal}>{1}</div>
                              </div>
                              {property.haveVal("direct_collection_fee") ? (
                                  <div
                                      className={styles.eachAttr}
                                      onClick={() =>
                                          this.props.toggleDetails(
                                              payment.itemId
                                          )
                                      }
                                  >
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.collection-fee",
                                              {},
                                              "Collection Fee"
                                          )}
                                      </h6>
                                      <div className={styles.attrVal}>
                                          {payment.direct_collection_fee}
                                      </div>
                                  </div>
                              ) : (
                                  ""
                              )}
                              {property.haveVal("fx_rate_payment") ? (
                                  <div
                                      className={styles.eachAttr}
                                      onClick={() =>
                                          this.props.toggleDetails(
                                              payment.itemId
                                          )
                                      }
                                  >
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.fx-rate",
                                              {},
                                              "FX Rate"
                                          )}
                                      </h6>
                                      <div className={styles.attrVal}>
                                          {payment.fx_rate_payment}
                                      </div>
                                  </div>
                              ) : (
                                  ""
                              )}
                              <div
                                  className={styles.eachAttr}
                                  onClick={() =>
                                      this.props.toggleDetails(payment.itemId)
                                  }
                              >
                                  <h6 className={styles.attrTitle}>
                                      {I18n.getText(
                                          "statement-details.total",
                                          {
                                              currency: currencyCode
                                          },
                                          "Subtotal ({currency})"
                                      )}
                                  </h6>
                                  <div
                                      className={`${
                                          payment.netDue < 0
                                              ? styles.negative
                                              : styles.positive
                                      }`}
                                  >
                                      {payment.netDue > 0 && "+"}&nbsp;{I18n.formatCurrency(
                                          Helper.formatPrice(
                                              payment.netDue,
                                              currencyCode
                                          )
                                      )}
                                  </div>
                              </div>
                          </div>
                      </div>
                  );
              })
            : "";

            const documentDetailsMobile = data
                ? data.map((payment, index) => {
                      return (
                          <div key={index} className={styles.ctr}>
                              <div className={styles.attrCtr}>
                                  <div className={styles.eachAttr}>
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.ref-no",
                                              {},
                                              "Reference Number"
                                          )}
                                      </h6>
                                      <div className={styles.attrVal}>
                                          {payment && payment.document_reference}
                                      </div>
                                  </div>
                                  <div className={styles.eachAttr}>
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.document-ref",
                                              {},
                                              "Document Type"
                                          )}
                                      </h6>
                                      <div className={styles.attrVal}>
                                          {payment && payment.document_type}
                                      </div>
                                  </div>
                                  <div
                                      className={styles.eachAttr}
                                  >
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.document-currency",
                                              {},
                                              "Currency"
                                          )}
                                      </h6>
                                      <div className={styles.attrVal}>{payment && payment.code}</div>
                                  </div>
                                  <div
                                      className={styles.eachAttr}
                                  >
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.fx-rate-payment",
                                              {},
                                              "FX Rate"
                                          )}
                                      </h6>
                                      <div className={styles.attrVal}>
                                          {payment && payment.fx_rate_payment}
                                      </div>
                                  </div>
                                  <div
                                      className={styles.eachAttr}
                                  >
                                      <h6 className={styles.attrTitle}>
                                          {I18n.getText(
                                              "statement-details.net-due",
                                              {},
                                              "Amount"
                                          )}
                                      </h6>
                                      <div
                                          className={`${
                                              payment.net_due < 0
                                                  ? styles.negative
                                                  : styles.positive
                                          }`}
                                      >
                                          {payment.net_due > 0 && "+"}&nbsp;{I18n.formatCurrency(
                                              Helper.formatPrice(
                                                  payment.net_due,
                                                  currencyCode
                                              )
                                          )}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      );
                  })
                : "";

        return (
            <div className={styles.scrollWrapper}>
                <div className={styles.scrollCtr}>
                    {docType === 1 ? paymentDetailsMobile : documentDetailsMobile}
                    {loadFunc && scroll && data && !_.isEmpty(data) ? (
                        <div>
                            <Waypoint onEnter={loadFunc} />
                            {!showNoLoading && <div>Loading...</div>}
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                <div className={styles.bottom}>
                    <p>
                        {I18n.getHtml(
                            "statement-details.subtotal",
                            {},
                            "SubTotal"
                        )}
                        :&nbsp;
                        {I18n.formatCurrency(
                            Helper.formatPrice(totalCredit, currencyCode)
                        )}
                    </p>
                    <p>
                        {I18n.getHtml(
                            "statement-details.deductions",
                            {},
                            "<strong>Total Deductions</strong>"
                        )}
                        :&nbsp;
                        {I18n.formatCurrency(
                            Helper.formatPrice(deductions, currencyCode)
                        )}
                    </p>
                </div>
            </div>
        );
    }
}

export default PaymentDetailsMobile;



// WEBPACK FOOTER //
// ./src/components/statement/paymentDetailsMobile/PaymentDetailsMobile.js